<template>
  <van-tabbar
      route
      v-model="activeValue"
      active-color="#74B42B"
      fixed
      style="background: rgba(237, 237, 237, 1);filter:blur(0px);z-index:100"
    >
      <van-tabbar-item replace to="/index">
       主页
       <template #icon="props">
       <img v-if="props.active"  src="@/assets/img/zhuye.png" alt=""  >
       <img  v-else  src="@/assets/img/zhuye-2.png" alt="" >
    </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/category" icon="apps-o">分类
       <template #icon="props">
       <img v-if="props.active"  src="@/assets/img/fenlei.png"  >
       <img  v-else  src="@/assets/img/fenlei-2.png" >
       </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/menuList" icon="apps-o"> 菜谱
       <template #icon="props">
       <img v-if="props.active"  src="@/assets/img/菜品-1.png"  >
       <img  v-else  src="@/assets/img/菜品-2.png" >
       </template>
       </van-tabbar-item>
      <van-tabbar-item replace to="/cart" icon="cart">购物车
       <template #icon="props">
       <img v-if="props.active"  src="@/assets/img/gouwuche.png"  >
       <img  v-else  src="@/assets/img/gouewuche-2.png" >
       </template>
       </van-tabbar-item>
      <van-tabbar-item replace to="/my" icon="manager-o">我的
       <template #icon="props">
       <img v-if="props.active"  src="@/assets/img/wode.png"  >
       <img  v-else  src="@/assets/img/wode-2.png" >
       </template>
      
      </van-tabbar-item>
    </van-tabbar>
</template>
<script>
export default {
  props: {
    activeNew: {
      default: 0
    }
  },
  computed: {
    activeValue: {
      get() {
        return this.activeNew;
      },
      set() {}
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang='scss'   scoped>
/deep/ .van-tabbar-item--active{
  background-color: transparent;
}
</style>
 